import { Icon } from "@iconify/react";
import "../styles/ErrorMessage.css";

function ErrorMessage({ message, onRetry }) {
  return (
    <div className="error-container">
      <div className="error-content">
        <Icon icon="mdi:alert-circle" className="error-icon" />
        <h2 className="error-title">Ops! Algo deu errado</h2>
        <p className="error-message">{message}</p>
        {onRetry && (
          <button onClick={onRetry} className="error-retry-button">
            <Icon icon="mdi:refresh" className="retry-icon" />
            Tentar novamente
          </button>
        )}
      </div>
    </div>
  );
}

export default ErrorMessage;
